/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { StatusWorkflowReplaceConfigurationResponse } from '../../models/status-workflow-replace-configuration-response';

export interface CommonControllerGetAllKeys$Params {
  entityTypeId: number;
}

export function commonControllerGetAllKeys(http: HttpClient, rootUrl: string, params: CommonControllerGetAllKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowReplaceConfigurationResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerGetAllKeys.PATH, 'get');
  if (params) {
    rb.path('entityTypeId', params.entityTypeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: StatusWorkflowReplaceConfigurationResponse;
      }>;
    })
  );
}

commonControllerGetAllKeys.PATH = '/common/keys/{entityTypeId}';
